
import * as React from "react";
import "./SnackBarPopup.css";
import { ISnackBackPopupProps } from "./Types";

export const SnackBarPopup = (props: ISnackBackPopupProps) => {
    if (!props.show) {
        return null;
    }
    const onDismiss = () => props.onDismiss();

    const timer = setTimeout(onDismiss, 10000);

    const onDismissClick = ()=> {
        clearTimeout(timer);
        onDismiss();
    }
    return (
        <div
            id="snackbar"
        >
            <p className="snackbar-message" >
                {props.text.message}
            </p>
            <button
                className="dismiss-button"
                onClick={onDismissClick}
            >
                {props.text.dismissText}
            </button>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/SnackBarPopup/SnackBarPopup.component.tsx